import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { RecipeModel } from 'src/app/core/model/object/recipe-model';
import { RecipeApiService } from 'src/app/data/repository/recipe-repository/recipe-api.service';
import { RecipeService } from 'src/app/data/repository/recipe-repository/recipe.service';

@Component({
  selector: 'app-cooking-story-search',
  templateUrl: './cooking-story-search.component.html',
  styleUrls: ['./cooking-story-search.component.scss'],
})
export class CookingStorySearchComponent implements OnInit, OnDestroy {
  public shadowNav: boolean = false;
  public showTyping: boolean = true;
  public showNotFound: boolean = false;
  public isSearch: boolean = false;
  public searchText: string;
  public searchedFood: RecipeModel[] = [];
  public page: number = 0;
  public sending: boolean = false;
  public count: number;
  @ViewChild('scroolEl') scroolEl: ElementRef<HTMLDivElement>;
  subscriptions: Subscription[] = [];

  txtQueryChanged: Subject<string> = new Subject<string>();
  options: AnimationOptions = {
    path: '/assets/animations/cookingstory.json',
    loop: false,
  };
  options2: AnimationOptions = {
    path: '/assets/animations/notfound.json',
    loop: false,
  };

  constructor(
    private recipeService: RecipeService,
    private recipeApi: RecipeApiService
  ) {
    const q = this.txtQueryChanged
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe((model) => {
        this.searchText = model;
        this.getRecipes(this.searchText, this.page);
      });
  }
  openRecipe(recipeId) {
    this.recipeService.goToRecipeDetail(recipeId);
  }
  ngOnInit(): void {}
  animationCreated(animationItem: AnimationItem): void {}
  goBack() {
    this.recipeService.back();
  }
  search(query: string) {
    if (query.length <= 0) {
      this.isSearch = false;
      this.showTyping = true;
      this.showNotFound = false;
      this.searchedFood = null;
    } else {
      this.txtQueryChanged.next(query);
    }
  }
  onkeydown(e) {
    if (
      (e.key == 'Backspace' && this.searchText.length <= 0) ||
      this.searchText === ''
    ) {
      this.isSearch = false;
      this.searchedFood = null;
    }
  }
  getRecipes(query: string, page: number) {
    this.sending = true;
    this.isSearch = true;
    this.showTyping = false;
    this.showNotFound = false;
    this.recipeApi.searchRecipes(query, null, page, 20).then((res) => {
      this.count = res.getData().getRecipeCategoryResponse().count;
      this.searchedFood.push(
        ...res.getData().getRecipeCategoryResponse().recipes
      );
      if (!this.searchedFood || this.searchedFood.length == 0) {
        this.showNotFound = true;
      }
      this.sending = false;
    });
  }
  clear() {
    this.searchText = null;
    this.showTyping = true;
    this.searchedFood = null;
  }
  scrolling(data) {
    let suggestEl = this.scroolEl.nativeElement;

    if (suggestEl.scrollTop >= 90) {
      this.shadowNav = true;
    } else {
      this.shadowNav = false;
    }
    if (
      suggestEl.scrollTop + suggestEl.clientHeight >=
      suggestEl.scrollHeight - 100
    ) {
      if (
        !this.sending &&
        this.count &&
        this.count > this.searchedFood.length &&
        this.searchText
      ) {
        this.page += 1;
        this.getRecipes(this.searchText, this.page);
      }
    }
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
}
